module.exports = __webpack_public_path__ + "img/alert-triangle_animated.704531df.svg";